const visus = [
	0.01, 0.012, 0.016,
	0.02, 0.025, 0.032,
	0.04, 0.05, 0.063,
	0.08, 0.1, 0.125,
	0.16, 0.2, 0.25,
	0.32, 0.4, 0.5,
	0.63, 0.8, 1.0,
	1.25, 1.6
];

export function smallestMeasurableVisus(): number {
	return visus[0];
}

export function getClosestVisus(v: number): number {
	return visus.reduce((prev, curr) => (Math.abs(curr - v) < Math.abs(prev - v) ? curr : prev));
}

export function getBedarf() {
	return [
		0.5,
		0.63,
		0.8,
		1,
		1.25,
		1.6,
		2,
		2.5,
		3.2,
		4,
		5,
		6.3,
		8,
		10,
		12.5,
		16,
		20
	];
}
